class CareerHeader {

  constructor() {
    this.hero = document.querySelector('.career-hero')
    if (this.hero) {
      this.container = this.hero.querySelector('.career-hero__images')
      this.fadeOnScroll()
      this.floatingAssets()
      this.videoListener()
      if (window.scrollY < this.container.scrollHeight / 2) {
        this.container.classList.add('scale')
      }
    }
  }

  fadeOnScroll() {
    window.addEventListener('scroll', () => {
      let normalized = ((window.scrollY - 0) / (this.hero.clientHeight / 2 - 0) * 100)
      if (window.scrollY > this.hero.clientHeight) {
        this.container.classList.add('scale')
        this.container.style.opacity = 0;
        Array.from(this.container.children).forEach(child => child.style.opacity = 0)
        this.container.style.transform = 'scale(0)'
      }
      if (normalized < 100) {
        let value = (100 - normalized) / 100
        this.container.style.opacity = value
        Array.from(this.container.children).forEach(child => child.style.opacity = value)
        this.container.style.transform = `scale(${value})`
      }
      if (normalized >= 100) {
        this.container.style.opacity = 0;
        Array.from(this.container.children).forEach(child => child.style.opacity = 0)
        this.container.style.transform = 'scale(0)'
      }
    })
  }

  floatingAssets() {
    let mousePos = {x:undefined, y:undefined}
    let running = false
    addEventListener('mousemove', ev => {
      mousePos.x = ev.clientX
      mousePos.y = ev.clientY
      let normalizedX = ((mousePos.x - 0) / (window.innerWidth - 0) * 100)
      let normalizedY = ((mousePos.y - 0) / (this.container.clientHeight - 0) * 100)
      let valueX = -normalizedX
      let valueY = -normalizedY
      this.container.style.transform = `scale(${this.container.style.opacity}) translateX(${valueX}px) translateY(${valueY}px)`
    })
  }

  videoListener() {
    const playBtn = document.querySelector('.career-hero__play-container')
    const thumbnail = document.querySelector('.career-hero__video-thumbnail')
    const video = document.querySelector('.career-hero__video')
    playBtn.addEventListener('click', () => {
      playBtn.remove()
      thumbnail.remove()
      video.play()
    })
  }

}

export default CareerHeader